import { Navigate, useLocation } from "react-router-dom";

export default function ApplicationIndexPage() {
  const location = useLocation();
  return <Navigate to={`${location.pathname}/overview`} replace />;
}
